import React from "react";
import "./style.css";
// import "./aepsBusinessBenefits.css";
// import "./aepsFeatures.css";
// import "./aepsWhyRetailers.css";

import aepsBanner from "./assets/aeps2.png";

const AepsSection = () => {
  return (
    <>
      {/* ===== AEPS Banner Section ===== */}
      <section className="aeps-section">
        <div className="aeps-content">
          <h2 className="aeps-title">AEPS Service</h2>
          <p className="aeps-subtitle">
            Fast, Secure, and Reliable Aadhaar Banking
          </p>

          <div className="aeps-image-wrapper">
            <img src={aepsBanner} alt="AEPS Banner" className="aeps-image" />
          </div>
        </div>
      </section>

      {/* ===== AEPS Description Section ===== */}
      <section className="aeps-description-section">
        <p className="aeps-text">
          The Aadhaar Enabled Payment System (AEPS) is a secure and convenient
          banking solution that allows customers to perform financial
          transactions using their Aadhaar number and biometric verification.
          AEPS enables cash withdrawals, balance inquiries, mini statements, and
          fund transfers—all without needing a debit card, PIN, or smartphone.
          For businesses seeking the best AEPS services in India, Omeswara
          offers a seamless, fast, and highly reliable system that supports
          financial inclusion across both rural and urban regions.
        </p>

        <p className="aeps-text">
          For retailers, merchants, and agents, AEPS registration online through
          Omeswara makes it easy to start offering doorstep and local banking
          services. This empowers individuals— especially those without
          traditional banking access—to withdraw cash, check balances, or
          transfer money instantly and securely. With Omeswara AEPS, customers
          enjoy convenience, and businesses gain an additional revenue stream.
        </p>
      </section>

      {/* ===== AEPS Business Benefits Section ===== */}
      <section className="benefit-section">
        <h2 className="benefit-title">
          How Business Owners and Merchants Benefit <br />
          from Omeswara AEPS Services
        </h2>

        <div className="benefit-box">
          <p className="benefit-text">
            Omeswara provides one of the most efficient and secure AEPS
            platforms, helping merchants deliver smooth banking services to
            their customers. Through simple AEPS online registration, businesses
            can quickly integrate Aadhaar-based transactions into their
            operations.
          </p>

          <p className="benefit-text">
            With biometric-based AEPS payments, merchants can: • Accept secure
            Aadhaar-enabled payments • Reduce dependency on physical cash •
            Offer banking facilities to customers without debit cards • Increase
            footfall and strengthen customer loyalty • Boost earnings through
            attractive AEPS commissions • Operate easily in both rural and urban
            markets
          </p>

          <p className="benefit-text">
            Omeswara AEPS helps merchants expand their payment capabilities,
            streamline transactions, and lower operational risks—making digital
            transactions more accessible than ever. Begin your AEPS registration
            today and experience secure, seamless Aadhaar banking with Omeswara.
          </p>
        </div>
      </section>

      {/* ===== AEPS Key Features Section ===== */}
      <section className="features-section">
        <h2 className="features-title">Key Features of Our AEPS Service:</h2>

        <div className="features-grid">
          {/* Card 1 */}
          <div className="feature-card">
            <h3 className="feature-title">Cash Withdrawal</h3>
            <p className="feature-text">
              Withdraw cash securely using your Aadhaar number and biometric
              authentication. Omeswara AEPS offers instant access to funds—fast,
              safe, and always reliable.
            </p>
          </div>

          {/* Card 2 */}
          <div className="feature-card">
            <h3 className="feature-title">Balance Inquiry</h3>
            <p className="feature-text">
              Check your bank account balance instantly with AEPS—no card
              required. After completing AEPS registration, customers enjoy
              smooth, cardless banking.
            </p>
          </div>

          {/* Card 3 */}
          <div className="feature-card">
            <h3 className="feature-title">Mini Statement</h3>
            <p className="feature-text">
              Get a quick view of recent transactions. Omeswara AEPS provides
              instant mini statements to help users track their account activity
              easily
            </p>
          </div>

          {/* Card 4 */}
          <div className="feature-card">
            <h3 className="feature-title">Fund Transfer</h3>
            <p className="feature-text">
              Transfer money securely to any bank account using Aadhaar
              authentication. With Omeswara’s AEPS platform, fund transfers are
              simple, fast, and PIN-free.
            </p>
          </div>

          {/* Card 5 */}
          <div className="feature-card">
            <h3 className="feature-title">24/7 Availability</h3>
            <p className="feature-text">
              Enjoy full-time banking access. Omeswara AEPS operates round the
              clock—allowing customers to withdraw cash, check balances, and
              transfer money anytime.
            </p>
          </div>
        </div>
      </section>

      {/* ===== WHY RETAILERS PREFER Omeswar ===== */}
      <section className="why-section">
        <h2 className="why-title">
          Why retailers prefer to become Omeswar AEPS <br /> Service Provider
        </h2>

        <div className="why-grid">
          <div className="why-card">Fast & Secure Transactions</div>
          <div className="why-card">Easy to Use</div>
          <div className="why-card">Best Commission & Earnings</div>
          <div className="why-card">Multi-Bank Support</div>
          <div className="why-card">24/7 Customer Support</div>
        </div>
      </section>
    </>
  );
};

export default AepsSection;
